import { render, staticRenderFns } from "./ProfileTopbar.vue?vue&type=template&id=31fbceba&scoped=true&"
import script from "./ProfileTopbar.vue?vue&type=script&lang=ts&"
export * from "./ProfileTopbar.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileTopbar.vue?vue&type=style&index=0&id=31fbceba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fbceba",
  null
  
)

export default component.exports